// @flow
import {cond, prop, T, propEq, compose, test, take, defaultTo} from 'ramda';

import {getProperty} from 'libs/utils/utils';

const emptyByDefault = defaultTo('');

/**
 * Get variant for product
 * @param {object} product - item
 * @param {string} frameSize - frame size product
 * @returns {string} - variant product
 */
export const getVariant = cond([
    [prop('is_contact_lenses'), product => `C|${emptyByDefault(product.lenstype)}`],
    [prop('isContactLenses'), product => `C|${emptyByDefault(product.lenstype)}`],
    [
        prop('color_value'),
        (product, frameSize) => `${frameSize}|${emptyByDefault(product.color_value[0])}`,
    ],
    [prop('variation'), product => product.variation],
    [
        getProperty('color.label'),
        (product, frameSize) => `${frameSize}|${getProperty('color.label')(product)}`,
    ],
    [T, (product, frameSize) => frameSize],
]);

/**
 * Return first letter of frame size
 * @type {Function}
 * @param {CartItemType} quote - item
 */
export const getFrameSize = compose(take(1), emptyByDefault, getProperty('frame.frameSize'));

/**
 * Return first letter of frame size from new endpoint
 * @type {Function}
 * @param {CartItemType} quote - item
 */
export const getFrameSizeV2 = compose(take(1), emptyByDefault, getProperty('size'));

/**
 * Get variant for quantity product
 * @param {object} product - item
 * @returns {string} - variant product
 */
export const getQuantityVariant = cond([
    [propEq('type', 'contact_lenses'), product => `C|${emptyByDefault(product.lensType)}`],
    [
        compose(test(/Little Kids/), getProperty('frame.frameSize')),
        product => `T|${emptyByDefault(getProperty('frame.color')(product))}`,
    ],
    [
        T,
        product =>
            `${getFrameSize(product)}|${emptyByDefault(getProperty('frame.color')(product))}`,
    ],
]);

/**
 * Get variant for quantity product from new endpoint
 * @param {object} product - item
 * @returns {string} - variant product
 */
export const getQuantityVariantV2 = cond([
    [propEq('type', 'contact_lenses'), product => `C|${emptyByDefault(product.lensType)}`],
    [
        compose(test(/Little Kids/), getProperty('size')),
        product => `T|${emptyByDefault(getProperty('color')(product))}`,
    ],
    [T, product => `${getFrameSizeV2(product)}|${emptyByDefault(getProperty('color')(product))}`],
]);
